import { AIChatWidget } from '@/components/ai/ai-chat-widget';
import TopNav from '@/components/navigation/top-nav';
import UserSidebar from '@/components/navigation/user-sidebar';
import { VerificationBanner } from '@/components/ui/verification-banner';
import { SidebarProvider, useSidebar } from '@/contexts/sidebar-context';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/(user-dashboard)/dashboard/_dashboard')({
  component: RouteComponent,
});

function DashboardLayout() {
  const { isOpen, isMobile } = useSidebar();

  return (
    <div className="flex h-screen overflow-hidden">
      <UserSidebar />
      <div
        className={`flex flex-1 flex-col min-w-0 transition-all duration-200 ease-in-out ${
          isOpen && !isMobile ? 'md:ml-64' : ''
        }`}
      >
        <VerificationBanner />
        <header className="h-16 border-b flex-shrink-0">
          <TopNav />
        </header>
        <main className="flex-1 overflow-auto p-3 sm:p-6">
          <AIChatWidget />
          <Outlet />
        </main>
      </div>
    </div>
  );
}

function RouteComponent() {
  return (
    <SidebarProvider>
      <DashboardLayout />
    </SidebarProvider>
  );
}
